<span
  class="text-ellipsis"
  [matTooltip]="tooltipValue()"
  [matTooltipDisabled]="tooltipDisabled() || !hasValue()"
  matTooltipShowDelay="300"
>
  {{ displayValue() }}
</span>
